import {
  GET_INVITES,
  RESET_INVITES,
} from '../actionTypes';

const initialState = {
  inviteesData: { invitees: [], count: 0 },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case RESET_INVITES:
    return initialState;
  case GET_INVITES: {
    const newInvitees = payload?.invitees ?? payload?.['0'] ?? [];
    const totalCount = payload?.total_count ?? 0;
    const page = payload?.page ?? 1;

    return {
      ...state,
      inviteesData: {
        invitees:
          page === 1
            ? newInvitees
            : [...state.inviteesData.invitees, ...newInvitees],
        count: totalCount,
      },
    };
  }
  default:
    return state;
  }
};
